(() => {
  if (customElements.get('rh-product-gallery')) return;
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [...this.querySelectorAll('[data-gallery-image]')];
      this.main = this.querySelector('.alu-gallery-image');
      this.zoom = this.querySelector('[data-zoom-image]');
      this.dialog = this.querySelector('dialog');
      this.index = 0;
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index)));
      this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.select(this.index - 1));
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.select(this.index + 1));
      this.querySelector('[data-open-image]').addEventListener('click', () => {
        this.zoom.src = this.main.src;
        this.zoom.alt = this.main.alt;
        this.dialog.showModal();
      });
      this.querySelector('[data-close-image]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); });
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      this.querySelector('[data-open-image]').addEventListener('touchstart', event => { this.touchStart = event.changedTouches[0].clientX; }, { passive: true });
      this.querySelector('[data-open-image]').addEventListener('touchend', event => {
        const delta = event.changedTouches[0].clientX - this.touchStart;
        if (Math.abs(delta) > 45) {
          this.select(this.index + (delta < 0 ? 1 : -1));
          this.suppressClick = true;
          setTimeout(() => { this.suppressClick = false; }, 400);
        }
      }, { passive: true });
      this.querySelector('[data-open-image]').addEventListener('click', event => {
        if (this.suppressClick) { event.stopImmediatePropagation(); if (this.dialog.open) this.dialog.close(); }
      }, true);
      this.querySelector('[data-gallery-count]').textContent = `1 / ${this.buttons.length}`;
      this.querySelectorAll('[data-gallery-image],[data-gallery-previous],[data-gallery-next],[data-open-image]').forEach(button => { button.disabled = false; });
      this.closest('.alu-page').querySelectorAll('.alu-information-nav a').forEach(link => link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        if (target?.tagName === 'DETAILS') target.open = true;
      }));
    }
    select(index) {
      this.index = (index + this.buttons.length) % this.buttons.length;
      const selected = this.buttons[this.index];
      this.main.removeAttribute('srcset');
      this.main.src = selected.dataset.imageSrc;
      this.main.alt = selected.dataset.imageAlt;
      this.buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === this.index)));
      this.querySelector('[data-gallery-count]').textContent = `${this.index + 1} / ${this.buttons.length}`;
      this.zoom.src = this.main.src;
      this.zoom.alt = this.main.alt;
    }
  }
  customElements.define('rh-product-gallery', ProductGallery);
})();

(() => {
  if (customElements.get('rh-product-information')) return;
  class ProductInformation extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const source = this.querySelector('.rh-description-source');
      const headings = /^(Toreigenschaften|Produkteigenschaften(?:\s*\/.*)?|Türeigenschaften|Einbaumaße|Antrieb|Ausstattung|Lieferumfang|Niedrigsturzbeschlag|Möglichkeiten zur Torbetätigung|Kompabilität|Kompatibilität|Oberfläche wählbar|Farbe außen wahlweise.*|Schlupftür|Anordnungsbeispiele|Beispielbilder(?: Anordnung der Sektionen)?|Abbildungsbeispiel|Anordnung der Sektionen)$/i;
      const groups = [{ title: this.dataset.descriptionLabel, nodes: [] }];
      let current = groups[0];
      for (const node of [...source.childNodes]) {
        if (node.nodeType === 3) {
          if (node.textContent.trim()) current.nodes.push(node);
          continue;
        }
        if (node.nodeType !== 1) continue;
        const text = node.textContent.replace(/\s+/g, ' ').trim().replace(/:$/, '');
        if (!text && !node.querySelector('img,video,iframe,table')) continue;
        if (/^H[2-6]$/.test(node.tagName) || (node.tagName === 'P' && headings.test(text))) {
          current = { title: text, nodes: [] };
          groups.push(current);
        } else {
          if (text.startsWith('Sollte es weitere Wünsche') || text.startsWith('Bitte beachten Sie, dass alle Tore')) {
            if (current.title !== this.dataset.descriptionLabel) {
              current = groups.find(group => group.title === this.dataset.descriptionLabel);
            }
          }
          current.nodes.push(node);
        }
      }
      const navigation = document.createElement('nav');
      navigation.className = 'alu-information-nav';
      navigation.setAttribute('aria-label', this.closest('.alu-information').querySelector('h2').textContent);
      const grid = document.createElement('div');
      grid.className = 'alu-information-grid';
      const features = groups.find(group => /^(Toreigenschaften|Produkteigenschaften)/i.test(group.title) && group.nodes.length);
      const panels = document.createElement('div');
      panels.className = 'alu-detail-panels';
      const addLink = (title, target) => {
        const link = document.createElement('a');
        link.textContent = title;
        link.href = `#${target.id}`;
        link.addEventListener('click', () => { if (target.tagName === 'DETAILS') target.open = true; });
        navigation.append(link);
      };
      const clean = container => {
        container.querySelectorAll('[style]').forEach(node => node.removeAttribute('style'));
        container.querySelectorAll('strong,b').forEach(node => node.replaceWith(...node.childNodes));
        container.querySelectorAll('img').forEach(image => {
          image.loading = 'lazy';
          image.decoding = 'async';
          if (!image.alt) image.alt = container.closest('details')?.querySelector('summary')?.textContent.replace('+', '').trim() || this.dataset.descriptionLabel;
        });
        container.querySelectorAll('p').forEach(node => {
          if (!node.textContent.trim() && !node.querySelector('img')) node.remove();
        });
      };
      if (features) {
        const section = document.createElement('section');
        section.className = 'alu-data';
        section.id = 'product-specifications';
        const heading = document.createElement('h3');
        heading.textContent = features.title;
        const body = document.createElement('div');
        body.className = 'alu-detail-body rh-specification-content';
        body.append(...features.nodes);
        clean(body);
        const list = document.createElement('dl');
        list.className = 'alu-specifications';
        body.querySelectorAll('li').forEach(item => {
          if (item.children.length && item.querySelector('li')) return;
          const value = item.textContent.trim();
          if (!value) return;
          const row = document.createElement('div');
          const split = value.indexOf(':');
          if (split > 0 && split < 65 && value.slice(split + 1).trim()) {
            const label = document.createElement('dt');
            label.textContent = value.slice(0, split);
            const detail = document.createElement('dd');
            detail.textContent = value.slice(split + 1).trim();
            row.append(label, detail);
          } else {
            const detail = document.createElement('dd');
            detail.textContent = value;
            row.className = 'rh-specification-full';
            row.append(detail);
          }
          list.append(row);
          item.remove();
        });
        body.querySelectorAll('ul,ol').forEach(node => { if (!node.textContent.trim()) node.remove(); });
        section.append(heading, list, body);
        grid.append(section);
        addLink(features.title, section);
      }
      groups.filter(group => group !== features && group.nodes.length).forEach((group, index) => {
        const detail = document.createElement('details');
        detail.className = 'alu-detail';
        detail.id = `product-detail-${index}`;
        const summary = document.createElement('summary');
        summary.textContent = group.title;
        const marker = document.createElement('span');
        marker.textContent = '+';
        marker.setAttribute('aria-hidden', 'true');
        summary.append(marker);
        const body = document.createElement('div');
        body.className = 'alu-detail-body';
        body.append(...group.nodes);
        detail.append(summary, body);
        clean(body);
        panels.append(detail);
        if (navigation.children.length < 6 && !/^(Abbildungsbeispiel|Anordnungsbeispiele|Beispielbilder|Farbe außen)/i.test(group.title)) addLink(group.title, detail);
        if (!features && index === 0) detail.open = true;
      });
      grid.append(panels);
      if (!features) grid.classList.add('rh-information-simple');
      this.replaceChildren(navigation, grid);
    }
  }
  customElements.define('rh-product-information', ProductInformation);
})();
